import { has, all, length } from 'ramda';

export const jobSkillQuestionCompleted = (job, minQuestions) =>
	has('skills', job) &&
	all(
		skill => has('selectedQuestions', skill) && length(skill.selectedQuestions) >= minQuestions,
		job.skills,
	);

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/components/third-step/evaluation-questions.utils.js